export default __webpack_public_path__ + "static/media/logosEmpresas.425beb2c.png";